/**
 * Small typed helpers around the DOM API.
 */

/** Return the first element matching `selector`, or `null`. */
export function query<T extends Element>(selector: string, root: ParentNode = document): T | null {
    return root.querySelector<T>(selector);
}

/** Return every element matching `selector` as a real array. */
export function queryAll<T extends Element>(selector: string, root: ParentNode = document): T[] {
    return Array.from(root.querySelectorAll<T>(selector));
}

/** Return the text content of `element` lowercased and whitespace collapsed. */
export function normalisedText(element: Element): string {
    return (element.textContent ?? "").replace(/\s+/g, " ").trim().toLowerCase();
}

/** Remove diacritics so that "pravidlá" also matches "pravidla". */
export function foldAccents(value: string): string {
    return value.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
}
